
import moment from 'moment-timezone'

export default {
    props: {
        // Eastern-only scheduler: render the appointment time in the zone it was
        // booked in -- never the browser's.
        timezone: { type: String, default: 'America/New_York' },
        time: { type: String, default: null },
    },
    data () { return { cancelConfirm: false } },
    computed: {
        whenLabel () {
            if (!this.time) return ''
            return moment.tz(this.time, this.timezone).format('dddd, MMMM D [at] h:mm A') + ' · Eastern Time'
        },
    },
}
